/* eslint-disable i18next/no-literal-string */
import { faCheck, faPlus, faStar, faTrash, faUser, faUserCircle, faUsers } from '@fortawesome/pro-regular-svg-icons';
import { addDays } from 'date-fns';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'src/components/Alert';
import { Avatar } from 'src/components/Avatar';
import { Badge } from 'src/components/Badge';
import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { Card, CardActions, CardContent } from 'src/components/Card';
import { Checkbox } from 'src/components/Checkbox';
import { Chip } from 'src/components/Chip';
import { ConfirmDialog } from 'src/components/ConfirmDialog';
import { PaymentMethodForm } from 'src/components/PaymentMethodForm';
import { ToggleButton } from 'src/components/ToggleButton';
import { ToggleButtonGroup } from 'src/components/ToggleButtonGroup';
import { ImageUploader } from 'src/components/Uploader/ImageUploader';
import { InlineFileUploader } from 'src/components/Uploader/InlineFileUploader';
import { UploadDialog } from 'src/components/Uploader/UploadDialog';
import { useOptionalSession } from 'src/contexts/SessionContext';
import {
  formatFullDate,
  formatFullDateAndTime,
  formatISODate,
  formatListDateAndTime,
  formatMonthDayYear,
  formatShortTimeAgo,
  formatStartAndEndTime,
  formatTime,
  formatTimeAgo,
} from 'src/utils/dateFormatter';

import { DatePicker } from '../components/DatePicker';
import { Dialog } from '../components/Dialog';
import { Divider } from '../components/Divider';
import { DndSortableList } from '../components/DndSortableList';
import { Drawer } from '../components/Drawer';
import { DropdownMenu } from '../components/DropdownMenu';
import { Icon } from '../components/Icon';
import { IconButton } from '../components/IconButton';
import { ListItem, ListItemSkeleton } from '../components/ListItem';
import { RadioGroup } from '../components/RadioGroup';
import { Scroller } from '../components/Scroller';
import { Stack } from '../components/Stack';
import { Sticky } from '../components/Sticky';
import { TextField } from '../components/TextField';
import { TitleAndClose } from '../components/TitleAndClose';
import { Typography } from '../components/Typography';
import { AppFrameConfig } from '../shared/AppFrame/AppFrameConfig';
import toast from '../utils/toast';

interface SortableListItem {
  id: string;
  label: string;
}

export default function Theme(): React.ReactNode {
  const [openDialog, setOpenDialog] = useState<string>('');
  const { user } = useOptionalSession();

  const errorToast = (): void => {
    toast.error('There was an error');
  };
  const successToast = (): void => {
    toast.success('Great success!');
  };

  const [sortableListItems, setSortableListItems] = useState<
    SortableListItem[]
  >([
    { id: 'a', label: 'A. Sortable Item' },
    { id: 'b', label: 'B. Sortable Item' },
    { id: 'c', label: 'C. Sortable Item' },
    { id: 'd', label: 'D. Sortable Item' },
  ]);
  const date = addDays(new Date(), 2);

  const handleToggleButtonChange = (): void => {
    // Demo handler for toggle buttons
  };

  const handleToggleButtonGroupChange = (): void => {
    // Demo handler for toggle button group
  };

  const handleTextFieldChange = (): void => {
    // Demo handler for text field
  };

  const handleCustomSelectChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    // Demo handler for custom select - event value available for demo purposes
    void event.target.value;
  };

  const handleImageSelect = (): void => {
    // Demo handler for image selection
  };

  const handleFileSelect = (): void => {
    // Demo handler for file selection
  };

  const handleFileUpload = (): void => {
    // Demo handler for file upload
  };

  return (
    <>
      <AppFrameConfig
        id="theme"
        title="Edit Theme"
        actions={[
          {
            label: 'Secondary Button',
            variant: 'outlined',
            onClick: successToast,
            icon: faPlus,
          },
          {
            label: 'Main Button',
            variant: 'contained',
            icon: faTrash,
          },
        ]}
      />
      <Drawer
        title="This is a drawer title"
        open={false}
        onClose={() => {
          return null;
        }}
      >
        <ListItemSkeleton primary secondary avatar />
        <ListItemSkeleton primary secondary avatar />
        <ListItemSkeleton primary secondary avatar />
        <ListItemSkeleton primary secondary avatar />
        <ListItemSkeleton primary secondary avatar />
        <ListItemSkeleton primary secondary avatar />
      </Drawer>
      <Dialog
        title="Dialog Title At vero eos et accusamus et iusto odio dignissimos ducimus qui Dialog Title At vero eos et accusamus et iusto odio dignissimos ducimus qui Dialog Title At vero eos et accusamus et iusto odio dignissimos ducimus qui"
        open={openDialog == 'dialog'}
        fullScreen={false}
        onClose={() => {
          setOpenDialog('');
        }}
        actions={
          <>
            <Button variant="text">Cancel</Button>
            <Button variant="contained">Action</Button>
          </>
        }
      >
        At vero eos et accusamus et iusto odio dignissimos ducimus qui
        blanditiis praesentium voluptatum deleniti atque corrupti quos dolores
        et quas molestias excepturi sint occaecati cupiditate non provident,
        similique sunt in culpa qui officia deserunt mollitia animi, id est
        laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita
        distinctio. Nam libero tempore, cum soluta nobis est eligendi optio
        cumque nihil impedit quo minus id quod maxime placeat facere possimus,
        omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem
        quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet
        ut et voluptates repudiandae sint et molestiae non recusandae. Itaque
        earum rerum hic tenetur a sapiente delectus, ut aut reiciendis
        voluptatibus maiores alias consequatur aut perferendis doloribus
        asperiores repellat. At vero eos et accusamus et iusto odio dignissimos
        ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti
        quos dolores et quas molestias excepturi sint occaecati cupiditate non
        provident, similique sunt in culpa qui officia deserunt mollitia animi,
        id est laborum et dolorum fuga. Et harum quidem rerum facilis est et
        expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi
        optio cumque nihil impedit quo minus id quod maxime placeat facere
        possimus, omnis voluptas assumenda est, omnis dolor repellendus.
        Temporibus autem quibusdam et aut officiis debitis aut rerum
        necessitatibus saepe eveniet ut et voluptates repudiandae sint et
        molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente
        delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut
        perferendis doloribus asperiores repellat. At vero eos et accusamus et
        iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum
        deleniti atque corrupti quos dolores et quas molestias excepturi sint
        occaecati cupiditate non provident, similique sunt in culpa qui officia
        deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem
        rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta
        nobis est eligendi optio cumque nihil impedit quo minus id quod maxime
        placeat facere possimus, omnis voluptas assumenda est, omnis dolor
        repellendus. Temporibus autem quibusdam et aut officiis debitis aut
        rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et
        molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente
        delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut
        perferendis doloribus asperiores repellat.
      </Dialog>
      <ConfirmDialog
        open={openDialog == 'confirm-dialog'}
        actions={[
          {
            label: 'Delete',
            color: 'error',
            variant: 'contained',
            onClick: () => {
              setOpenDialog('');
            },
          },
          {
            label: 'Cancel',
            color: 'error',
            variant: 'outlined',
            onClick: () => {
              setOpenDialog('');
            },
          },
        ]}
        title="Are you sure you want to delete this item?"
      >
        You can not undo this.
        <br />
        Line two text.
      </ConfirmDialog>
      <Stack direction="column" gap={7} my={10}>
        <Divider />
        <Stack>
          <Typography variant="h1" mb={2} gutterBottom>
            Heading 1
          </Typography>
          <Typography variant="h2" mb={2} gutterBottom>
            Heading 2
          </Typography>
          <Typography variant="h3" mb={2} gutterBottom>
            Heading 3
          </Typography>
          <Typography variant="h4" mb={2} gutterBottom>
            Heading 4
          </Typography>
          <Typography variant="h5" mb={2} gutterBottom>
            Heading 5
          </Typography>
          <Typography variant="h6" mb={2} gutterBottom>
            Heading 6
          </Typography>
          <Typography variant="subtitle1" mb={2} gutterBottom>
            Subtitle 1
          </Typography>
          <Typography variant="subtitle2" mb={2} gutterBottom>
            Subtitle 2
          </Typography>
          <Typography variant="body1" mb={2} gutterBottom>
            Body 1
          </Typography>
          <Typography variant="body2" mb={2} gutterBottom>
            Body 2
          </Typography>
          <Typography variant="caption" mb={2} gutterBottom>
            Caption
          </Typography>
          <Typography variant="overline" mb={2} gutterBottom>
            Overline
          </Typography>
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Colors
        </Typography>
        <Stack>
          <Typography color="text" gutterBottom>
            Primary Text Color
          </Typography>
          <Typography color="textSecondary" gutterBottom>
            Secondary Text Color
          </Typography>
          <Typography gutterBottom color="primary">
            Primary
          </Typography>
          <Typography gutterBottom color="secondary">
            Secondary
          </Typography>
          <Typography gutterBottom color="error">
            Error
          </Typography>
          <Typography gutterBottom color="warning">
            Warning
          </Typography>
          <Typography gutterBottom color="success">
            Success
          </Typography>
        </Stack>
        <Stack>
          <Stack>
            <Box height="40px" bgcolor="primary.main" p={1}>
              <Typography color="primary.contrastText" gutterBottom>
                Primary color
              </Typography>
            </Box>
            <Box mb={0} display="flex">
              <Box height="50px" width="100%" bgcolor="primary.lightest"></Box>
              <Box height="50px" width="100%" bgcolor="primary.light"></Box>
              <Box height="50px" width="100%" bgcolor="primary.main"></Box>
              <Box height="50px" width="100%" bgcolor="primary.dark"></Box>
              <Box height="50px" width="100%" bgcolor="primary.darkest"></Box>
            </Box>
            <Box height="40px" bgcolor="primary.og" p={1}>
              <Typography color="primary.contrastText" gutterBottom>
                Original color
              </Typography>
            </Box>
            <Box mb={4} display="flex">
              <Box height="50px" width="100%" bgcolor="primary.50"></Box>
              <Box height="50px" width="100%" bgcolor="primary.100"></Box>
              <Box height="50px" width="100%" bgcolor="primary.200"></Box>
              <Box height="50px" width="100%" bgcolor="primary.300"></Box>
              <Box height="50px" width="100%" bgcolor="primary.400"></Box>
              <Box height="50px" width="100%" bgcolor="primary.500"></Box>
              <Box height="50px" width="100%" bgcolor="primary.600"></Box>
              <Box height="50px" width="100%" bgcolor="primary.700"></Box>
              <Box height="50px" width="100%" bgcolor="primary.800"></Box>
              <Box height="50px" width="100%" bgcolor="primary.900"></Box>
              <Box height="50px" width="100%" bgcolor="primary.950"></Box>
            </Box>
            <Box mb={4} display="flex">
              <Box height="50px" width="100%" bgcolor="primary.1"></Box>
              <Box height="50px" width="100%" bgcolor="primary.2"></Box>
              <Box height="50px" width="100%" bgcolor="primary.3"></Box>
              <Box height="50px" width="100%" bgcolor="primary.4"></Box>
              <Box height="50px" width="100%" bgcolor="primary.5"></Box>
              <Box height="50px" width="100%" bgcolor="primary.6"></Box>
              <Box height="50px" width="100%" bgcolor="primary.7"></Box>
              <Box height="50px" width="100%" bgcolor="primary.8"></Box>
              <Box height="50px" width="100%" bgcolor="primary.9"></Box>
              <Box height="50px" width="100%" bgcolor="primary.10"></Box>
              <Box height="50px" width="100%" bgcolor="primary.11"></Box>
              <Box height="50px" width="100%" bgcolor="primary.12"></Box>
            </Box>

            <Box height="40px" bgcolor="secondary.main" p={1}>
              <Typography color="secondary.contrastText" gutterBottom>
                Secondary color
              </Typography>
            </Box>
            <Box mb={1} display="flex">
              <Box
                height="50px"
                width="100%"
                bgcolor="secondary.lightest"
              ></Box>
              <Box height="50px" width="100%" bgcolor="secondary.light"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.main"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.dark"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.darkest"></Box>
            </Box>
            <Box mb={4} display="flex">
              <Box height="50px" width="100%" bgcolor="secondary.50"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.100"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.200"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.300"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.400"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.500"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.600"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.700"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.800"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.900"></Box>
              <Box height="50px" width="100%" bgcolor="secondary.950"></Box>
            </Box>

            <Box height="40px" bgcolor="info.main" p={1}>
              <Typography color="info.contrastText" gutterBottom>
                Info color
              </Typography>
            </Box>
            <Box mb={1} display="flex">
              <Box height="50px" width="100%" bgcolor="info.lightest"></Box>
              <Box height="50px" width="100%" bgcolor="info.light"></Box>
              <Box height="50px" width="100%" bgcolor="info.main"></Box>
              <Box height="50px" width="100%" bgcolor="info.dark"></Box>
              <Box height="50px" width="100%" bgcolor="info.darkest"></Box>
            </Box>
            <Box mb={4} display="flex">
              <Box height="50px" width="100%" bgcolor="info.50"></Box>
              <Box height="50px" width="100%" bgcolor="info.100"></Box>
              <Box height="50px" width="100%" bgcolor="info.200"></Box>
              <Box height="50px" width="100%" bgcolor="info.300"></Box>
              <Box height="50px" width="100%" bgcolor="info.400"></Box>
              <Box height="50px" width="100%" bgcolor="info.500"></Box>
              <Box height="50px" width="100%" bgcolor="info.600"></Box>
              <Box height="50px" width="100%" bgcolor="info.700"></Box>
              <Box height="50px" width="100%" bgcolor="info.800"></Box>
              <Box height="50px" width="100%" bgcolor="info.900"></Box>
              <Box height="50px" width="100%" bgcolor="info.950"></Box>
            </Box>

            <Box height="40px" bgcolor="warning.main" p={1}>
              <Typography color="warning.contrastText" gutterBottom>
                Warning color
              </Typography>
            </Box>
            <Box mb={1} display="flex">
              <Box height="50px" width="100%" bgcolor="warning.lightest"></Box>
              <Box height="50px" width="100%" bgcolor="warning.light"></Box>
              <Box height="50px" width="100%" bgcolor="warning.main"></Box>
              <Box height="50px" width="100%" bgcolor="warning.dark"></Box>
              <Box height="50px" width="100%" bgcolor="warning.darkest"></Box>
            </Box>
            <Box mb={4} display="flex">
              <Box height="50px" width="100%" bgcolor="warning.50"></Box>
              <Box height="50px" width="100%" bgcolor="warning.100"></Box>
              <Box height="50px" width="100%" bgcolor="warning.200"></Box>
              <Box height="50px" width="100%" bgcolor="warning.300"></Box>
              <Box height="50px" width="100%" bgcolor="warning.400"></Box>
              <Box height="50px" width="100%" bgcolor="warning.500"></Box>
              <Box height="50px" width="100%" bgcolor="warning.600"></Box>
              <Box height="50px" width="100%" bgcolor="warning.700"></Box>
              <Box height="50px" width="100%" bgcolor="warning.800"></Box>
              <Box height="50px" width="100%" bgcolor="warning.900"></Box>
              <Box height="50px" width="100%" bgcolor="warning.950"></Box>
            </Box>

            <Box height="40px" bgcolor="error.main" p={1}>
              <Typography color="error.contrastText" gutterBottom>
                Error color
              </Typography>
            </Box>
            <Box mb={1} display="flex">
              <Box height="50px" width="100%" bgcolor="error.lightest"></Box>
              <Box height="50px" width="100%" bgcolor="error.light"></Box>
              <Box height="50px" width="100%" bgcolor="error.main"></Box>
              <Box height="50px" width="100%" bgcolor="error.dark"></Box>
              <Box height="50px" width="100%" bgcolor="error.darkest"></Box>
            </Box>
            <Box mb={4} display="flex">
              <Box height="50px" width="100%" bgcolor="error.50"></Box>
              <Box height="50px" width="100%" bgcolor="error.100"></Box>
              <Box height="50px" width="100%" bgcolor="error.200"></Box>
              <Box height="50px" width="100%" bgcolor="error.300"></Box>
              <Box height="50px" width="100%" bgcolor="error.400"></Box>
              <Box height="50px" width="100%" bgcolor="error.500"></Box>
              <Box height="50px" width="100%" bgcolor="error.600"></Box>
              <Box height="50px" width="100%" bgcolor="error.700"></Box>
              <Box height="50px" width="100%" bgcolor="error.800"></Box>
              <Box height="50px" width="100%" bgcolor="error.900"></Box>
              <Box height="50px" width="100%" bgcolor="error.950"></Box>
            </Box>

            <Box height="40px" bgcolor="success.main" p={1}>
              <Typography color="success.contrastText" gutterBottom>
                Success color
              </Typography>
            </Box>
            <Box mb={1} display="flex">
              <Box height="50px" width="100%" bgcolor="success.lightest"></Box>
              <Box height="50px" width="100%" bgcolor="success.light"></Box>
              <Box height="50px" width="100%" bgcolor="success.main"></Box>
              <Box height="50px" width="100%" bgcolor="success.dark"></Box>
              <Box height="50px" width="100%" bgcolor="success.darkest"></Box>
            </Box>
            <Box mb={4} display="flex">
              <Box height="50px" width="100%" bgcolor="success.50"></Box>
              <Box height="50px" width="100%" bgcolor="success.100"></Box>
              <Box height="50px" width="100%" bgcolor="success.200"></Box>
              <Box height="50px" width="100%" bgcolor="success.300"></Box>
              <Box height="50px" width="100%" bgcolor="success.400"></Box>
              <Box height="50px" width="100%" bgcolor="success.500"></Box>
              <Box height="50px" width="100%" bgcolor="success.600"></Box>
              <Box height="50px" width="100%" bgcolor="success.700"></Box>
              <Box height="50px" width="100%" bgcolor="success.800"></Box>
              <Box height="50px" width="100%" bgcolor="success.900"></Box>
              <Box height="50px" width="100%" bgcolor="success.950"></Box>
            </Box>
          </Stack>
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Icon
        </Typography>
        <Stack direction="row" gap={2} flexWrap="wrap">
          <Icon size="tiny" icon={faStar} />
          <Icon
            color="secondary"
            size="tiny"
            icon={faStar}
          />
          <Icon
            color="primary"
            size="tiny"
            icon={faStar}
          />
          <Icon
            color="action"
            size="tiny"
            icon={faStar}
          />
          <Icon
            color="success"
            size="tiny"
            icon={faStar}
          />
          <Icon
            color="error"
            size="tiny"
            icon={faStar}
          />
          <Icon
            color="warning"
            size="tiny"
            icon={faStar}
          />
        </Stack>
        <Stack direction="row" gap={2} flexWrap="wrap">
          <Icon size="xsmall" icon={faStar} />
          <Icon
            color="secondary"
            size="xsmall"
            icon={faStar}
          />
          <Icon
            color="primary"
            size="xsmall"
            icon={faStar}
          />
          <Icon
            color="action"
            size="xsmall"
            icon={faStar}
          />
          <Icon
            color="success"
            size="xsmall"
            icon={faStar}
          />
          <Icon
            color="error"
            size="xsmall"
            icon={faStar}
          />
          <Icon
            color="warning"
            size="xsmall"
            icon={faStar}
          />
        </Stack>
        <Stack direction="row" gap={2} flexWrap="wrap">
          <Icon size="small" icon={faStar} />
          <Icon
            color="secondary"
            size="small"
            icon={faStar}
          />
          <Icon
            color="primary"
            size="small"
            icon={faStar}
          />
          <Icon
            color="action"
            size="small"
            icon={faStar}
          />
          <Icon
            color="success"
            size="small"
            icon={faStar}
          />
          <Icon
            color="error"
            size="small"
            icon={faStar}
          />
          <Icon
            color="warning"
            size="small"
            icon={faStar}
          />
        </Stack>
        <Stack direction="row" gap={2} flexWrap="wrap">
          <Icon size="medium" icon={faStar} />
          <Icon
            color="secondary"
            size="medium"
            icon={faStar}
          />
          <Icon
            color="primary"
            size="medium"
            icon={faStar}
          />
          <Icon
            color="action"
            size="medium"
            icon={faStar}
          />
          <Icon
            color="success"
            size="medium"
            icon={faStar}
          />
          <Icon
            color="error"
            size="medium"
            icon={faStar}
          />
          <Icon
            color="warning"
            size="medium"
            icon={faStar}
          />
        </Stack>
        <Stack direction="row" gap={2} flexWrap="wrap">
          <Icon size="large" icon={faStar} />
          <Icon
            color="secondary"
            size="large"
            icon={faStar}
          />
          <Icon
            color="primary"
            size="large"
            icon={faStar}
          />
          <Icon
            color="action"
            size="large"
            icon={faStar}
          />
          <Icon
            color="success"
            size="large"
            icon={faStar}
          />
          <Icon
            color="error"
            size="large"
            icon={faStar}
          />
          <Icon
            color="warning"
            size="large"
            icon={faStar}
          />
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Button
        </Typography>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="contained">
            Primary Contained
          </Button>
          <Button color="secondary" variant="contained">
            Secondary Contained
          </Button>
          <Button color="success" variant="contained">
            Success Contained
          </Button>
          <Button color="error" variant="contained">
            Error Contained
          </Button>
          <Button color="warning" variant="contained">
            Warning Contained
          </Button>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="contained" disabled>
            Primary Disabled
          </Button>
          <Button color="secondary" variant="contained" disabled>
            Secondary Disabled
          </Button>
          <Button color="success" variant="contained" disabled>
            Success Contained
          </Button>
          <Button color="error" variant="contained" disabled>
            Error Disabled
          </Button>
          <Button color="warning" variant="contained" disabled>
            Warning Disabled
          </Button>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="outlined">
            Primary Outlined
          </Button>
          <Button color="secondary" variant="outlined">
            Secondary Outlined
          </Button>
          <Button color="success" variant="outlined">
            Success Outlined
          </Button>
          <Button color="error" variant="outlined">
            Error Outlined
          </Button>
          <Button color="warning" variant="outlined">
            Warning Outlined
          </Button>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="outlined" disabled>
            Primary Outlined Disabled
          </Button>
          <Button color="secondary" variant="outlined" disabled>
            Secondary Outlined Disabled
          </Button>
          <Button color="success" variant="outlined" disabled>
            Success Outlined Disabled
          </Button>
          <Button color="error" variant="outlined" disabled>
            Error Outlined Disabled
          </Button>
          <Button color="warning" variant="outlined" disabled>
            Warning Outlined Disabled
          </Button>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="text">
            Primary Text
          </Button>
          <Button color="secondary" variant="text">
            Secondary Text
          </Button>
          <Button color="success" variant="text">
            Success Text
          </Button>
          <Button color="error" variant="text">
            Error Text
          </Button>
          <Button color="warning" variant="text">
            Warning Text
          </Button>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="contained" size="small">
            Primary Contained
          </Button>
          <Button color="secondary" variant="contained" size="small">
            Secondary Contained
          </Button>
          <Button color="success" variant="contained" size="small">
            Success Contained
          </Button>
          <Button color="error" variant="contained" size="small">
            Error Contained
          </Button>
          <Button color="warning" variant="contained" size="small">
            Warning Contained
          </Button>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="outlined" size="small">
            Primary Outlined
          </Button>
          <Button color="secondary" variant="outlined" size="small">
            Secondary Outlined
          </Button>
          <Button color="success" variant="outlined" size="small">
            Success Outlined
          </Button>
          <Button color="error" variant="outlined" size="small">
            Error Outlined
          </Button>
          <Button color="warning" variant="outlined" size="small">
            Warning Outlined
          </Button>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button color="primary" variant="text" size="small">
            Primary Text
          </Button>
          <Button color="secondary" variant="text" size="small">
            Secondary Text
          </Button>
          <Button color="success" variant="text" size="small">
            Success Text
          </Button>
          <Button color="error" variant="text" size="small">
            Error Text
          </Button>
          <Button color="warning" variant="text" size="small">
            Warning Text
          </Button>
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          IconButton
        </Typography>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <IconButton>
            <Icon
              size="medium"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="secondary">
            <Icon
              size="medium"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="primary">
            <Icon
              size="medium"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="success">
            <Icon
              size="medium"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="error">
            <Icon
              size="medium"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="warning">
            <Icon
              size="medium"
              icon={faStar}
            />
          </IconButton>
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <IconButton>
            <Icon
              size="small"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="secondary">
            <Icon
              size="small"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="primary">
            <Icon
              size="small"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="success">
            <Icon
              size="small"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="error">
            <Icon
              size="small"
              icon={faStar}
            />
          </IconButton>
          <IconButton color="warning">
            <Icon
              size="small"
              icon={faStar}
            />
          </IconButton>
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Button Events
        </Typography>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <DropdownMenu
            closeOnContentClick={false}
            trigger={
              <Button color="primary" variant="outlined">
                Open Dropdown
              </Button>
            }
          >
            <ListItem primary="ListItemTitle" />
            <ListItem primary="ListItemTitle" />
          </DropdownMenu>

          <Button
            color="primary"
            variant="outlined"
            onClick={() => setOpenDialog('dialog')}
          >
            Open Dialog
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setOpenDialog('confirm-dialog')}
          >
            Open Confirm Dialog
          </Button>

          <Button color="success" variant="outlined" onClick={successToast}>
            Success Toast
          </Button>
          <Button color="error" variant="outlined" onClick={errorToast}>
            Error Toast
          </Button>
          <Button color="warning" variant="outlined" onClick={errorToast}>
            Warning Toast
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              throw new Error('Sentry Test Error');
            }}
          >
            Break the world
          </Button>
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Toggle Button / Toggle Button Group
        </Typography>
        <Stack direction="column" spacing={2}>
          <Typography variant="body2">Standalone button</Typography>
          <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
            <ToggleButton
              value="check"
              selected={true}
              onChange={handleToggleButtonChange}
            >
              <Icon
                size="medium"
                icon={faStar}
              />
            </ToggleButton>
            <ToggleButton
              value="check"
              selected={false}
              onChange={handleToggleButtonChange}
            >
              <Icon
                size="medium"
                icon={faStar}
              />
            </ToggleButton>
          </Stack>

          <Typography variant="body2">Toggle Button Group</Typography>
          <Stack direction="row" spacing={1}>
            <ToggleButtonGroup
              color="primary"
              value="web"
              exclusive
              onChange={handleToggleButtonGroupChange}
            >
              <ToggleButton value="web">Web</ToggleButton>
              <ToggleButton value="android">Android</ToggleButton>
              <ToggleButton value="ios">iOS</ToggleButton>
            </ToggleButtonGroup>
            <ToggleButtonGroup
              color="primary"
              value="web"
              exclusive
              onChange={handleToggleButtonGroupChange}
            >
              <ToggleButton value="web">
                <Icon
                  size="medium"
                  icon={faUser}
                />
              </ToggleButton>
              <ToggleButton value="android">
                <Icon
                  size="medium"
                  icon={faUsers}
                />
              </ToggleButton>
              <ToggleButton value="ios">
                <Icon
                  size="medium"
                  icon={faUserCircle}
                />
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </Stack>
        <Typography variant="h3" gutterBottom>
          Badge
        </Typography>
        <Box>
          <Badge badgeContent="1000" max={99} overlap="circular">
            <Avatar initials="DM"></Avatar>
          </Badge>

          <Badge
            badgeContent="1"
            color="error"
            sx={{ ml: 3 }}
            overlap="circular"
          >
            <IconButton>
              <Icon
                size="medium"
                icon={faStar}
              />
            </IconButton>
          </Badge>

          <Badge
            icon={faCheck}
            color="success"
            sx={{ ml: 3 }}
            overlap="circular"
          >
            <Avatar initials="DM"></Avatar>
          </Badge>
        </Box>
        <Box>
          <Badge badgeContent="1000" max={99}>
            <Avatar initials="DM"></Avatar>
          </Badge>

          <Badge badgeContent="1" color="error" sx={{ ml: 3 }}>
            <IconButton>
              <Icon
                size="medium"
                icon={faStar}
              />
            </IconButton>
          </Badge>

          <Badge
            icon={faCheck}
            color="success"
            sx={{ ml: 3 }}
          >
            <Avatar initials="DM"></Avatar>
          </Badge>
        </Box>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Chip
        </Typography>
        <Box>
          <Stack direction="row" mb={2} gap={2} flexWrap="wrap">
            <Chip
              variant="soft"
              component={Link}
              label="Default"
              to="/"
              onClick={() => {}}
            />
            <Chip
              label="Deletable"
              variant="soft"
              onDelete={() => {
                return null;
              }}
            />
            <Chip variant="soft" color="primary" label="Primary Soft" />
            <Chip
              variant="soft"
              color="primary"
              label="Primary Soft"
              onDelete={() => {
                return null;
              }}
              onClick={() => {}}
            />
            <Chip
              variant="soft"
              color="primary"
              label="Primary Soft Disabled"
              disabled
              onDelete={() => {
                return null;
              }}
              onClick={() => {}}
            />
            <Chip variant="soft" color="secondary" label="Secondary Soft" />
            <Chip
              variant="soft"
              color="primary"
              label="Primary Soft"
              onDelete={() => {
                return null;
              }}
            />
            <Chip variant="soft" color="success" label="Success Soft" />
            <Chip
              variant="soft"
              color="success"
              label="Success Soft"
              onDelete={() => {
                return null;
              }}
            />
            <Chip variant="soft" color="info" label="Info Soft" />
            <Chip
              variant="soft"
              color="info"
              label="Info Soft"
              onDelete={() => {
                return null;
              }}
            />
            <Chip variant="soft" color="warning" label="Warning Soft" />
            <Chip
              variant="soft"
              color="warning"
              label="Warning Soft"
              onDelete={() => {
                return null;
              }}
            />
            <Chip variant="soft" color="error" label="Error Soft" />
            <Chip
              variant="soft"
              color="error"
              label="Error Soft"
              onDelete={() => {
                return null;
              }}
            />
          </Stack>

          <Stack direction="row" mb={2} gap={2} flexWrap="wrap">
            <Chip component={Link} label="Default" to="/" />
            <Chip
              label="Deletable"
              onDelete={() => {
                return null;
              }}
            />
            <Chip variant="outlined" color="primary" label="Primary Outined" />
            <Chip
              active={false}
              variant="outlined"
              color="primary"
              label="Primary Outlined"
              onDelete={() => {
                return null;
              }}
            />
            <Chip variant="outlined" label="Outined" />
            <Chip
              active={false}
              variant="outlined"
              label="Outlined"
              onDelete={() => {
                return null;
              }}
            />
          </Stack>

          <Stack direction="row" mb={2} gap={2}>
            <Chip variant="outlined" label="Active" active />
            <Chip variant="outlined" label="Inactive" />
          </Stack>
        </Box>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Card
        </Typography>
        <Card>
          <TitleAndClose
            title="This is the title"
            onClose={() => {
              return null;
            }}
          />
          <CardContent sx={{ px: 2, pb: 2, pt: 0 }}>
            At vero eos et accusamus et iusto odio dignissimos ducimus qui
            blanditiis praesentium voluptatum deleniti atque corrupti quos
            dolores
          </CardContent>
          <CardActions sx={{ p: 2 }}>
            <Button color="primary" variant="contained">
              Primary Button
            </Button>
            <Button color="secondary" variant="contained">
              Secondary Button
            </Button>
          </CardActions>
        </Card>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Radio
        </Typography>
        <RadioGroup
          label="Radio Group Label"
          options={[
            { value: 'value1', label: 'label1' },
            { value: 'value2', label: 'label2' },
            { value: 'value3', label: 'label3' },
          ]}
        />
        <Divider />
        <Typography variant="h3" gutterBottom>
          Checkbox
        </Typography>
        <Box>
          <Checkbox sx={{ mr: 4 }} label="Checkbox Label" />
          <Checkbox useSwitch label="Switch Label" />
        </Box>
        <Divider />
        <Typography variant="h3" gutterBottom>
          TextField
        </Typography>
        <Stack direction="row" gap={2}>
          <TextField
            placeholder="placeholder"
            label="Select Label"
            value="b"
            onChange={handleTextFieldChange}
            options={[
              { value: 'a', label: 'Option A', disabled: true },
              { value: 'b', label: 'Option B' },
              { value: 'c', label: 'Option C' },
            ]}
          />
          <TextField
            label="Custom Content Select"
            value="b"
            onChange={handleCustomSelectChange}
            customOptions={sortableListItems.map((item) => (
              <ListItem
                primary={item.label}
                value={item.id}
                key={item.id}
                sx={{ mx: 1, my: 0.25 }}
                icon={faStar}
                rounded
              >
                {item.label}
              </ListItem>
            ))}
          />
        </Stack>
        <Stack direction="row" gap={2}>
          <TextField
            placeholder="placeholder"
            label="Label"
            value=""
            helperText="Hello"
            onChange={handleTextFieldChange}
          />

          <DatePicker label="Datepicker Label" helperText="Hello" />
        </Stack>
        <Stack direction="row" gap={2}>
          <TextField
            label="Textarea Label"
            multiline
            placeholder="This is textarea"
            value="This textarea has a value now"
            onChange={handleTextFieldChange}
          />
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          Alert
        </Typography>
        <Stack direction="column" gap={2}>
          <Alert severity="success">This is a success Alert.</Alert>
          <Alert severity="info">This is an info Alert.</Alert>
          <Alert severity="warning">This is a warning Alert.</Alert>
          <Alert
            severity="error"
            action={
              <Button size="small" color="inherit">
                Action
              </Button>
            }
          >
            This is an error Alert.
          </Alert>
          <Alert
            title="Alert With Title & Action"
            action={
              <Button size="small" color="inherit">
                Action
              </Button>
            }
            severity="success"
          >
            This is a success Alert.
          </Alert>
        </Stack>
        <Divider />
        <Typography variant="h3" gutterBottom>
          ListItem
        </Typography>
        <Stack direction="column" gap={1}>
          <ListItem primary="List Item" />
          <ListItem primary="List Item" secondary="Secondary text" />
          <ListItem
            primary="List Item With Adornment"
            secondary="Secondary text"
            rightAdornment="DM"
          />
          <ListItem
            primary="List Item With Icon"
            secondary="Secondary text"
            icon={faStar}
            indent="medium"
          />
          <ListItem
            primary="List Item with Medium Indent"
            secondary="Secondary text"
            indent="medium"
          />
          <ListItem
            primary="List Item With Avatar"
            secondary="Secondary text"
            avatar={<Avatar initials="DM"></Avatar>}
          />
          <ListItem
            primary="List Item with Large Indent"
            secondary="Secondary text"
            indent="large"
          />
          <ListItem
            primary="List Item With Icon and Large Indent"
            secondary="Secondary text"
            icon={faStar}
            indent="large"
          />
          <ListItem
            primary="List Item With Centered Indent"
            secondary="Secondary text"
            avatar={<Avatar initials="DM"></Avatar>}
            centerIndent
          />
          <ListItem
            primary="List Item With Centered Indent"
            secondary="Secondary text"
            icon={faStar}
            indent="large"
            centerIndent
          />
        </Stack>
        {user && (
          <>
            <Divider />
            <Typography variant="h3" gutterBottom>
              Payment Forms
            </Typography>

            <Typography variant="h4" gutterBottom>
              Add Payment Method
            </Typography>
            <PaymentMethodForm
              user={user}
              handlePaymentMethodAdded={() => null}
            />
          </>
        )}
        <Divider />
        <Typography variant="h3" gutterBottom>
          Drag and Drop Sortable List
        </Typography>

        <Card variant="outlined">
          <DndSortableList
            items={sortableListItems}
            setItems={setSortableListItems}
          >
            {(item, { isDragging }) => {
              return (
                <ListItem
                  primary={item.label}
                  secondary="Click and drag me"
                  rounded
                  sx={{
                    bgcolor: isDragging
                      ? 'background.level3'
                      : 'background.level2',
                  }}
                ></ListItem>
              );
            }}
          </DndSortableList>
        </Card>

        <Divider />

        <Typography variant="h3" gutterBottom>
          Sticky Content
        </Typography>
        <Box height="600px">
          <Scroller direction="column">
            <Stack>
              <Box height="100px" color="primary" bgcolor="primary.lightest">
                <Typography>Above Sticky Content</Typography>
              </Box>
              <Sticky>
                <Box height="100px" bgcolor="error.light">
                  <Typography>Sticky Content</Typography>
                </Box>
              </Sticky>
              <Box height="1000px" bgcolor="success.light">
                <Typography>Below Sticky Content</Typography>
              </Box>
            </Stack>
          </Scroller>
        </Box>

        <Divider />

        <Typography variant="h3" gutterBottom>
          File Uploaders
        </Typography>

        <Stack spacing={4}>
          <Box>
            <Typography variant="h6" gutterBottom>
              Image Uploader
            </Typography>
            <ImageUploader
              title="Select Avatar"
              subtitle="Min 400x400p, PNG or JPEG"
              onImageSelect={handleImageSelect}
            />
          </Box>
          <Box>
            <Typography variant="h6" gutterBottom>
              File Upload Dialog
            </Typography>
            <Button
              variant="outlined"
              onClick={() => setOpenDialog('file')}
              sx={{ width: 200 }}
            >
              Open Upload File Dialog
            </Button>
          </Box>
          <Box>
            <Typography variant="h6" gutterBottom>
              Inline File Uploader
            </Typography>
            <InlineFileUploader
              accept={{ 'image/*': [], 'application/pdf': [] }}
              onFileSelect={handleFileSelect}
              multiple={false}
            />
          </Box>
          <UploadDialog
            open={openDialog == 'file'}
            onClose={() => setOpenDialog('')}
            onUpload={handleFileUpload}
          />
        </Stack>
        <Typography variant="h3" gutterBottom>
          Date Formats
        </Typography>
        <Stack>
          <ListItem secondary="formatTime" primary={formatTime(date)} />
          <ListItem secondary="formatTimeAgo" primary={formatTimeAgo(date)} />
          <ListItem
            secondary="formatShortTimeAgo"
            primary={formatShortTimeAgo(date)}
          />
          <ListItem
            secondary="formatListDateAndTime"
            primary={formatListDateAndTime(date)}
          />
          <ListItem
            secondary="formatStartAndEndTime"
            primary={formatStartAndEndTime(date, date)}
          />
          <ListItem secondary="formatISODate" primary={formatISODate(date)} />
          <ListItem
            secondary="formatFullDateAndTime"
            primary={formatFullDateAndTime(date)}
          />
          <ListItem secondary="formatFullDate" primary={formatFullDate(date)} />
          <ListItem
            secondary="formatMonthDayYear"
            primary={formatMonthDayYear(date)}
          />
        </Stack>
      </Stack>
    </>
  );
}
